import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';

class Layout extends React.PureComponent {
    state = {
        allList: this.props.content?.pageData?.list || [],
        filterList: this.props.content?.pageData?.list || [],
        isSearch: false,
        inputText: '',
        bref: this.props.content?.pageData?.desc || '',
        hasShadow: false,
    };

    returnList = () => {
        const { allList } = this.state;

        this.setState({
            filterList: allList,
            inputText: '',
            isSearch: false,
        });
    };

    searchHandle = () => {
        const { inputText, allList } = this.state;
        const filterList = [];
        const inputContent = inputText.toLocaleLowerCase();

        if (inputText.trim() !== '') {
            allList.map((item) => {
                if (
                    item?.name?.toString?.()?.toLocaleLowerCase?.()?.includes?.(inputContent) ||
                    // item?.title?.toString?.()?.toLocaleLowerCase?.()?.includes?.(inputContent) ||
                    item?.job?.toString?.()?.toLocaleLowerCase?.()?.includes?.(inputContent) ||
                    item?.idea?.toString?.()?.toLocaleLowerCase?.()?.includes?.(inputContent)
                ) {
                    filterList.push(item);
                }

                return item;
            });
        }

        this.setState({
            filterList,
            isSearch: true,
        });
    };

    changeInput = (event) => {
        const { allList } = this.state;

        if (event.target.value !== '') {
            this.setState({
                inputText: event.target.value,
            });
        } else {
            this.setState({
                isSearch: false,
                inputText: '',
                filterList: allList,
            });
        }
    };

    render() {
        const { filterList, bref, isSearch, inputText, hasShadow } = this.state;

        return (
            <div className={styles.layout}>
                <div className={styles.bref}>{bref}</div>
                <div className={styles.search}>
                    <div className={`${styles.searchBox} ${hasShadow ? styles.searchBoxShadow : ''}`} ref={this.searchRef}>
                        <div className={styles.searchInput}>
                            <input type="text" onChange={this.changeInput} value={inputText} placeholder="搜索关键词" />
                        </div>
                        <div onClick={this.searchHandle} className={styles.searchIcon}>
                            {/* 搜索 */}
                        </div>
                        {isSearch && (
                            <div onClick={this.returnList} className={styles.rankButton}>
                                取消
                            </div>
                        )}
                    </div>
                </div>
                <div className={styles.tableBox}>
                    <table cellPadding="0" cellSpacing="0" className={styles.tableList}>
                        <thead>
                            <tr>
                                {/* <th className={styles.firstname}>姓名</th> */}
                                <th className={styles.firstname}>委员/代表</th>
                                {/* <th className={styles.secondname}>委员/代表</th> */}
                                <th>职务</th>
                                <th>提案/议案</th>
                            </tr>
                        </thead>
                        <tbody>
                            {filterList.slice(0, 500).length > 0 ? (
                                filterList.map((item, index) => {
                                    return (
                                        <tr key={index}>
                                            <td>{item.name}</td>
                                            {/* <td>{item.title}</td> */}
                                            <td>{item.job}</td>
                                            <td>
                                                <a href={item.url} target="_blank" rel="noreferrer">
                                                    {item.idea}
                                                </a>
                                            </td>
                                        </tr>
                                    );
                                })
                            ) : (
                                <tr className={styles.searchInfo}>
                                    <td colSpan="6">{inputText ? '暂无相关提案议案' : '抱歉，请您输入关键词后再进行搜索'}</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        );
    }
}

Layout.propTypes = {
    content: PropTypes.object,
};

export default errorBoundary(Layout);
